import createCache, { type EmotionCache } from '@emotion/cache';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';

/**
 * Emotion caches for LTR and RTL. The RTL cache runs `stylis-plugin-rtl`, which
 * flips physical CSS properties (margin/padding/left/right, text-align, etc.)
 * so MUI's `sx` styling mirrors correctly for Arabic. Pair with the
 * direction-aware theme in App.tsx.
 */
export const ltrCache: EmotionCache = createCache({
  key: 'mui-ltr',
  stylisPlugins: [prefixer],
});

export const rtlCache: EmotionCache = createCache({
  key: 'mui-rtl',
  stylisPlugins: [prefixer, rtlPlugin],
});

export function cacheForDirection(direction: 'ltr' | 'rtl'): EmotionCache {
  return direction === 'rtl' ? rtlCache : ltrCache;
}
